import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './index.scss'

class Radio extends React.Component {
  state = { checked: false }

  handleChange = () => {
    console.log('props.name', this.props.input.name)
    if (this.props.onChange) {
      this.props.onChange(this.props.value)
    }

    if (this.props.input && this.props.input.onChange) {
      this.props.input.onChange(this.props.input.value)
    }

    this.setState({
      // eslint-disable-next-line react/no-unused-state
      checked: this.inputRef.checked,
    })
  }

  isChecked = () => this.inputRef.checked

  render() {
    const {
      checked,
      children,
      disabled,
      input,
      label,
      meta,
      name,
      onChecked,
      value,
    } = this.props

    const id = this.props.id || Math.random()

    return (
      <div>
        <div className={classnames('cri-container')}>
          <label className="cri-container" htmlFor={id}>
            {label || '\u00A0'}
            <input
              checked={input.checked || checked}
              disabled={disabled || meta.submitting}
              id={id}
              name={name || input.name}
              type="radio"
              value={input.value || value}
              {...input}
              onChange={this.handleChange}
              ref={el => (this.inputRef = el)}
            />
            <span className="checkmark" />
          </label>
        </div>

        {typeof children === 'function' && (
          <div>
            {children((this.inputRef && this.inputRef.checked) || checked)}
          </div>
        )}

        {typeof onChecked === 'function' && this.state.checked && (
          <div>{onChecked()}</div>
        )}
      </div>
    )
  }
}

Radio.propTypes = {
  children: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  id: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChecked: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
}
Radio.defaultProps = {
  children: null,
  checked: undefined,
  disabled: false,
  id: undefined,
  input: {},
  meta: {},
  name: '',
  onChange: undefined,
  onChecked: undefined,
  value: true,
}

export default Radio
